import { render, staticRenderFns } from "./DatasetTitle.vue?vue&type=template&id=3dee5e2e&scoped=true&"
import script from "./DatasetTitle.vue?vue&type=script&lang=js&"
export * from "./DatasetTitle.vue?vue&type=script&lang=js&"
import style0 from "./DatasetTitle.vue?vue&type=style&index=0&id=3dee5e2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dee5e2e",
  null
  
)

export default component.exports